"use client"

interface FormCheckboxProps {
    label: string
    checked: boolean
    onChange: (checked: boolean) => void
    description?: string
}

export default function FormCheckbox({ label, checked, onChange, description }: FormCheckboxProps) {
    return (
        <div className="flex items-start">
            <div className="flex items-center h-5">
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => onChange(e.target.checked)}
                    className="w-4 h-4 text-primary-600 border-gray-300 rounded focus:ring-primary-500"
                />
            </div>
            <div className="ml-3">
                <label className="text-sm font-medium text-gray-700">{label}</label>
                {description && <p className="text-sm text-gray-500">{description}</p>}
            </div>
        </div>
    )
}
